/*
* @Author: gujianghua
* @Date:   2018-07-06 14:35:15
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-28 09:52:40
*/
import { service,BASE_API } from '@/utils/request'

/**
 * 静态url
 * [baseUrl 公共域名]
 * @type {[obj]}
 */
const baseUrl = BASE_API

export const captcha = baseUrl + '/cloud/uac/v1/captcha/img/generate'

export function login(data) {
	return service ({
		url: '/cloud/uac/admin/auth/login',
		method: 'post',
		data
	})
}

export function sendSms(data) {
	return service ({
		url: '/cloud/uac/admin/auth/sendSms',
		method: 'post',
		data
	})
}


// WEBPACK FOOTER //
// ./src/api/login/index.js